// extracted by mini-css-extract-plugin
module.exports = {"root":"card_root__1asO-","content":"card_content__1TDIu","footer":"card_footer__3o8a2","header":"card_header__1PJiX"};